export enum ReferralScheduleStatusTypesEnum {
    Approved = 1,
    ClaimantNotified = 2,
    AttendanceRejected = 3,
    ClaimantNotAttended = 4,
    Completed = 5,
    VendorCancelled = 6,
    AdjusterCancelled = 7,
    UnableToExamine = 9
}